import { render, staticRenderFns } from "./widgetPiePercentageChart.vue?vue&type=template&id=48b1d3e4&scoped=true&"
import script from "./widgetPiePercentageChart.vue?vue&type=script&lang=js&"
export * from "./widgetPiePercentageChart.vue?vue&type=script&lang=js&"
import style0 from "./widgetPiePercentageChart.vue?vue&type=style&index=0&id=48b1d3e4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b1d3e4",
  null
  
)

export default component.exports